var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02a9f4",
    d: "M59 5v4H1V5a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M55 1h-3a4 4 0 0 1 4 4v4h3V5a4 4 0 0 0-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M59 9v46a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M56 9v46a4 4 0 0 1-4 4h3a4 4 0 0 0 4-4V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M43 21.83V41a2.006 2.006 0 0 1-2 2H19a2.006 2.006 0 0 1-2-2V15a2.006 2.006 0 0 1 2-2h15.17c.286-.001.57.06.83.18V19a2.006 2.006 0 0 0 2 2h5.82c.12.26.181.544.18.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M42.82 21h-3c.12.26.181.544.18.83V41a2.006 2.006 0 0 1-2 2h3a2.006 2.006 0 0 0 2-2V21.83c.001-.286-.06-.57-.18-.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3a",
    d: "M42.82 21H37a2.006 2.006 0 0 1-2-2v-5.82c.22.1.42.24.59.41l6.82 6.82c.17.17.31.37.41.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f44335",
    d: "M32 48V38a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10h-4l6 7 6-7z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5 60h50a5.006 5.006 0 0 0 5-5V5a5.006 5.006 0 0 0-5-5H5a5.006 5.006 0 0 0-5 5v50a5.006 5.006 0 0 0 5 5zm50-2H5a3 3 0 0 1-3-3V10h56v45a3 3 0 0 1-3 3zM5 2h50a3 3 0 0 1 3 3v3H2V5a3 3 0 0 1 3-3z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.293 6.707a1 1 0 0 0 1.414 0L6 6.414l.293.293a1 1 0 0 0 1.414-1.414L7.414 5l.293-.293a1 1 0 0 0-1.414-1.414L6 3.586l-.293-.293a1 1 0 0 0-1.414 1.414L4.586 5l-.293.293a1 1 0 0 0 0 1.414z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 5,
    r: 1,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 5,
    r: 1,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 5,
    r: 1,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M36.3 12.883A2.987 2.987 0 0 0 34.17 12H19a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h8v3h-3a1 1 0 0 0-.759 1.651l6 7a1 1 0 0 0 1.518 0l6-7A1 1 0 0 0 36 47h-3v-3h8a3 3 0 0 0 3-3V21.83a2.987 2.987 0 0 0-.883-2.127zm-.3 2.531L40.586 20H37a1 1 0 0 1-1-1zM33.826 49 30 53.463 26.174 49H28a1 1 0 0 0 1-1V38h2v10a1 1 0 0 0 1 1zM41 42h-8v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4h-8a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1h15v5a3 3 0 0 0 3 3h5v19a1 1 0 0 1-1 1z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.b91ebbf00c93d6838dfc6fa3f1bec769.svg";
export { ForwardRef as ReactComponent };